exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vlSelected > div > div[data-v-5ee7444d] {\n  font-weight: bold;\n}\n.vlIconText > div[data-v-5ee7444d] {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0.5rem;\n}\n.vlIconText > div > i[data-v-5ee7444d] {\n  text-align: center;\n}\n.vlIconText > div > div[data-v-5ee7444d] {\n  flex: 1;\n}", ""]);

// exports
